import { useState, useEffect, useContext, useCallback, useMemo } from "react";
import { Button, Backdrop, CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Container from "@mui/material/Container";
import Stack from "@mui/material/Stack";
import { DataGrid, jaJP } from "@mui/x-data-grid";
import { API, CSV_ADDITIVE, PAGE_SIZE, MSG } from "./constantsFront";
import * as React from 'react';
import _ from 'lodash';
import { MsgContext } from "../../App";
//import { AuthInfoContext } from "./AuthContextProvider.tsx";
import { CSVLink } from "react-csv";
import { useDropzone } from "react-dropzone";
import Encoding from "encoding-japanese";
import CSVReader from 'react-csv-reader'

/**
 * 添加物一覧
 * @returns 
 */
function G0212EuAdditiveList() {
    const [pageSize, setPageSize] = useState(PAGE_SIZE);
    const [AdditiveRows, setAdditiveRows] = useState([]); // 添加物

    const { msg, setMsg } = useContext(MsgContext);// エラーメッセージ
    const [selectedFile, setSelectedFile] = useState(); // 選択したファイル
    const [fileData, setFileData] = useState(); // 選択したファイルデータ
    const [csvErrorMsg, setCsvErrorMsg] = useState([]); // CSVアップロードエラーメッセージ
    const [isLoading, setIsLoading] = useState(false);  // Loading
    const navigate = useNavigate();
    let body = { authKey: API.API_KEY };

    // CSVヘッダ
    const csvHeader = [
        { label: "添加物カテゴリーナンバー", key: "additive_category_number" },
        { label: "Eナンバー", key: "e_number" },
        { label: "添加物名_JP", key: "additive_name_jp" },
        { label: "添加物名_EN", key: "additive_name_en" },
        { label: "和名頭文字", key: "ja_initials" },
        { label: "国の規制", key: "national_regulations" },
        { label: "備考", key: "remarks" },
        { label: "個別名称登録フラグ", key: "is_registration_individual_name" },
        { label: "グループ脚注", key: "group_footnote" },
    ];

    useEffect(() => {
        displayData();
    }, [])

    // 表示データ用
    function displayData() {
        // 添加物一覧取得
        axios.post("/m_eu_additive_list/select/auth", body).then(res => {
            // 取得チェック
            if (res.status != 200) {
                return;
            }
            let AdditiveList = res.data.dataList;
            let rowsData = [];
            for (let i in AdditiveList) {
                rowsData.push({
                    id: i
                    , additive_category_number: AdditiveList[i].additive_category_number
                    , e_number: AdditiveList[i].e_number
                    , additive_name_jp: AdditiveList[i].additive_name_jp
                    , additive_name_en: AdditiveList[i].additive_name_en
                    , ja_initials: AdditiveList[i].ja_initials
                    , national_regulations: AdditiveList[i].national_regulations
                    , remarks: AdditiveList[i].remarks
                    , is_registration_individual_name: AdditiveList[i].is_registration_individual_name
                    , group_footnote: AdditiveList[i].group_footnote
                });
            }
            setAdditiveRows(rowsData);
        }).catch(error => {
            console.log('error:', error);
            setMsg(MSG.EXCEPTION);
        });
    }

    // ヘッダー
    const AdditiveColumns = [
        { field: "additive_category_number", headerName: "カテゴリー", width: 100 },
        { field: "e_number", headerName: "Eナンバー", width: 100 },
        { field: "additive_name_jp", headerName: "添加物名", width: 300 },
        { field: "additive_name_en", headerName: "添加物英語名", width: 300 },
        { field: "national_regulations", headerName: "国の規制", width: 200 },
        { field: "remarks", headerName: "備考", width: 300 },
        { field: "group_footnote", headerName: "グループ脚注", width: 300 },
        // {
        //     field: "edit", headerName: "", sortable: false, disableClickEventBubbling: true, width: 50,
        //     renderCell: (params) => <Tooltip title="表示" arrow><IconButton ><RemoveRedEyeIcon /></IconButton></Tooltip>
        // },
    ];

    // CSVファイルを選択時trueを設定
    const changeHandlerCsv = (event) => {
        setSelectedFile(event.target.files[0]);
        event.target.value = '';
    };

    // ファイル選択ボタン
    const onDrop = useCallback((acceptedFiles) => {
        setSelectedFile(acceptedFiles[0]);
    }, []);
    const { open, acceptedFiles } = useDropzone({
        accept: {
            'text/csv': [],
        },
        multiple: false,
        onDrop,
        noClick: true
    });
    const files = useMemo(() =>
        acceptedFiles.map((file) => (
            <li style={{ listStyleType: "none" }} key={file.path}>
                {file.path}
            </li>
        )
        ), [acceptedFiles]);

    // CSVアップロードボタン
    const handleFiles = files => {
        try {

            setFileData();
            setSelectedFile();
            setCsvErrorMsg([]);
            if (!selectedFile) {
                return setMsg("ファイルを選択してください");
            }

            let reader = new FileReader();
            reader.readAsArrayBuffer(selectedFile);

            reader.onload = async function (e) {
                let uniqueList = [];
                let csletr = [];

                const codes = new Uint8Array(e.target.result);
                const encoding = Encoding.detect(codes);
                const unicodeString = Encoding.convert(codes, {
                    to: 'unicode',
                    from: encoding,
                    type: 'string',
                });

                // 改行ごとに配列化
                let lines = unicodeString.split(/\r\n|\n/);
                if (lines[lines.length - 1] == '') {
                    let lines_before = lines.pop();  // 配列の最後の要素を削除（空ができるときがある）
                }

                // 1行ごとに処理
                for (let i = 0; i < lines.length; i++) {
                    //現在の行数
                    let row = i + 1;

                    // 必須チェックエラーカウント
                    var csvError = 0;

                    //カンマとダブルクォーテーションのエスケープ
                    let cells = lines[i].split(',').reduce(([data, isInQuotes], text) => {
                        if (isInQuotes) {
                            data[data.length - 1] += ',' + text.replace(/\"+/g, m => '"'.repeat(m.length / 2))
                            return [data, !(text.match(/\"*$/)[0].length % 2)]
                        } else {
                            const match = text.match(/^(\"?)((.*?)(\"*))$/)
                            data.push(match[1] ? match[2].replace(/\"+/g, m => '"'.repeat(m.length / 2)) : match[2])
                            return [data, match[1] && !(match[4].length % 2)]
                        }
                    }, [[]])[0];

                    //CSVの中身が正しい場合
                    if (cells.length == 9) {

                        uniqueList.push(cells[0]);
                        csletr.push(cells);

                        // 必須チェック開始
                        if (csletr[i][CSV_ADDITIVE.CATEGORY_NUMBER] == '') {
                            csvError++;
                            csvErrorMsg.push(row + "行目 : カテゴリーナンバーは必須です。");
                        }

                        if (csletr[i][CSV_ADDITIVE.E_NUMBER] == '') {
                            csvError++;
                            csvErrorMsg.push(row + "行目 : Eナンバーは必須です。");
                        }

                        if (csvError > 0) {
                            return setMsg(csvErrorMsg.join('<br />'));
                        }

                        // 必須チェック終了

                    } else {
                        return setMsg("項目の数が正しくありません。");
                    }
                }

                console.log("CSVのチェックが終わりました。");

                // Loading
                setIsLoading(true);

                let arrStr = JSON.stringify(csletr);
                body.arrStr = arrStr

                const res1 = await axios.post("/m_eu_additive_list/upload/auth", body);
                if (res1.status === 200) {
                    displayData();
                    alert("アップロードに成功しました。");
                    setIsLoading(false);
                }
            }
        } catch (err) {
            setIsLoading(false);
            setMsg("登録に失敗しました。");
            return;
        }
    }

    return (
        <>
            <div class="mainLinkMenu"></div>
            <div id="homeContents">
                <div class="homeContentsInner">
                    <div class="mainCont">
                        <div class="selectSearchArea">

                            <Container maxWidth="lg" id="container">
                                {/* Loading */}
                                <Backdrop open={isLoading}
                                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
                                    <CircularProgress />
                                </Backdrop>

                                <Stack spacing={2}>
                                    <h1>添加物一覧</h1>

                                    <Stack spacing={2} direction="row">
                                        <Button href="./G0211FoodAdditive"
                                            style={{
                                                width: "200px"
                                                , color: "white"
                                                , textDecoration: "none"
                                            }}>
                                            戻る
                                        </Button>

                                        <CSVLink style={{ color: "white", textDecoration: "none" }}
                                            filename={"添加物一覧.csv"} headers={csvHeader} data={AdditiveRows}>
                                            <Button
                                                style={{ width: "200px" }}>CSVダウンロード
                                            </Button>
                                        </CSVLink>
                                    </Stack>
                                    <Stack spacing={2} direction="row">

                                        <Button style={{ width: "200px" }} variant="contained" component="label" onChange={changeHandlerCsv}>
                                            CSVファイルを選択
                                            <CSVReader
                                                inputStyle={{ display: "none" }}
                                                onFileLoaded={(data, fileInfo, originalFile) => setFileData(data)}
                                            />
                                        </Button>
                                        {selectedFile != null ? (
                                            <>
                                                <div>
                                                    <p>ファイル名: {selectedFile.name}</p>
                                                </div>
                                                <Button
                                                    style={{ width: "200px" }}
                                                    onClick={handleFiles}
                                                >
                                                    登録実行
                                                </Button>
                                            </>
                                        ) : (
                                            <div><p>CSVファイルが選択されていません</p></div>
                                        )}

                                    </Stack>

                                    <div style={{ width: "100%" }}>
                                        <DataGrid
                                            className="DataGrid"
                                            columns={AdditiveColumns}
                                            rows={AdditiveRows}
                                            autoHeight
                                            disableSelectionOnClick
                                            pageSize={pageSize}
                                            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                                            pagination
                                            localeText={jaJP.components.MuiDataGrid.defaultProps.localeText}
                                        />
                                    </div>


                                </Stack>
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default G0212EuAdditiveList;